import { BlitzPage, Routes } from "@blitzjs/next"
import { useMutation } from "@blitzjs/rpc"
import { useRouter } from "next/router"
import arrayMutators from "final-form-arrays"
import Container from "@mui/material/Container"
import Typography from "@mui/material/Typography"

import Layout from "app/core/layouts/Layout"
import Suspense from "app/core/components/Suspense"
import createPipeline from "app/pipelines/mutations/createPipeline"
import { CreatePipeline, Dir } from "app/pipelines/validations"
import { PipelineForm, FORM_ERROR } from "app/pipelines/components/PipelineForm"
import { MeasurementSystem, TargetSystem } from "app/orders/validations"

const NewPipelinePage: BlitzPage = () => {
  const router = useRouter()
  const [createPipelineMutation] = useMutation(createPipeline)

  return (
    <Container maxWidth={false}>
      <Typography sx={{ my: 4 }} variant="h4" component="h2">
        Create New Pipeline
      </Typography>

      <Suspense>
        <PipelineForm
          submitText="Create Pipeline"
          schema={CreatePipeline}
          initialValues={{
            description: null,
            metaTitle: null,
            metaDescription: null,
            firstPageTitle: null,
            measurementSystem: MeasurementSystem.METRIC,
            dir: Dir.LTR,
            blogLink: null,
            targetSystem: TargetSystem.API_DIET,
            validateEmailDomain: false,
          }}
          mutators={{ ...arrayMutators }}
          onSubmit={async (values) => {
            try {
              await createPipelineMutation(values)
              await router.push(Routes.PipelinesPage())
            } catch (error) {
              console.error(error)
              return {
                [FORM_ERROR]: error.toString(),
              }
            }
          }}
        />
      </Suspense>
    </Container>
  )
}

NewPipelinePage.authenticate = true
NewPipelinePage.getLayout = (page) => <Layout title={"Create New Pipeline"}>{page}</Layout>

export default NewPipelinePage
